export const LINGUE = [
  { value: "it", flag: "italy.webp", label: "Italiano" },
  { value: "en", flag: "england.webp", label: "English" },
  // { value: "fr", flag: "france.webp", label: "Français" },
];
